import styled from "styled-components";
import { TypoCaption3 } from "@/styles/Styled.Typography";
import { fluid } from "@/styles/utils/fluid";

export const HighlightsWrapper = styled.ul`
  width: 100%;
  height: auto;
  list-style-type: none;
  padding: 0;
  display: grid;
  margin: ${({ theme }) => `
    ${fluid({
      minSize: theme.spacing.section.xs,
      maxSize: theme.spacing.section.xl,
      minVW: theme.breakpointValues.xs,
      maxVW: theme.breakpointValues.xl,
      baseFontMin: theme.baseFont.xs,
      baseFontMax: theme.baseFont.xl,
    })}
    0
  `};
  gap: ${({ theme }) => `
    ${fluid({
      minSize: theme.spacing.element.xs,
      maxSize: theme.spacing.element.md,
      minVW: theme.breakpointValues.xs,
      maxVW: theme.breakpointValues.md,
      baseFontMin: theme.baseFont.xs,
      baseFontMax: theme.baseFont.md,
    })}
    0
  `};
  /* xs only */
  @media ${({ theme }) => theme.breakpoints.xs} {
    grid-template-columns: 1fr;
  }
  /* sm and up */
  @media ${({ theme }) => theme.breakpoints.sm} {
    grid-template-columns: 1fr;
  }
  /* sm to md */
  @media ${({ theme }) => theme.breakpoints.md} {
    grid-template-columns: 1fr;
    &:nth-child(1) {
      grid-area: 1 / center-start / 2 / center-end;
    }
    &:nth-child(2) {
      grid-area: 2 / center-start / 3 / center-end;
    }
    &:nth-child(3) {
      grid-area: 3 / center-start / 4 / center-end;
    }
  }
  /* md and up */
  @media ${({ theme }) => theme.breakpoints.lg} {
    grid-template-columns: auto min-content auto min-content auto;
    gap: 0;
  }
  /* lg to xl */
  @media ${({ theme }) => theme.breakpoints.xl} {
    grid-template-columns: auto min-content auto min-content auto;
    gap: 0;
  }
`;

export const HighlightsItem = styled.li`
  display: grid;
  position: relative;
  width: 100%;
  border-radius: 32px;
  border: 4px solid ${({ theme }) => theme.colors.onyx};
  &::before {
    content: "";
    background-color: ${({ theme }) => theme.colors.white};
    outline: 4px solid ${({ theme }) => theme.colors.white};
    position: absolute;
    border-radius: 24px;
    top: 4px;
    left: 4px;
    right: 4px;
    bottom: 4px;
    z-index: -1;
    background-image: url("data:image/svg+xml,%3csvg width='100%25' height='100%25' xmlns='http://www.w3.org/2000/svg'%3e%3crect width='100%25' height='100%25' fill='none' rx='24' ry='24' stroke='%23333' stroke-width='2' stroke-dasharray='8%2c 8' stroke-dashoffset='0' stroke-linecap='square'/%3e%3c/svg%3e");
  }
  /* sm and up */
  @media ${({ theme }) => theme.breakpoints.sm} {
    grid-template-columns: 1fr;
    grid-template-rows: auto;
    height: min-content;
  }
  /* sm to md */
  @media ${({ theme }) => theme.breakpoints.md} {
    grid-template-columns: 1fr;
    grid-template-rows: auto;
    height: min-content;
  }
  /* md and up */
  @media ${({ theme }) => theme.breakpoints.lg} {
    grid-template-columns: auto min-content;
    height: 75vh;
    &:nth-child(1) {
      z-index: 3;
      grid-area: 1 / 1 / 2 / 3;
    }
    &:nth-child(2) {
      z-index: 2;
      grid-area: 1 / 2 / 2 / 5;
    }
    &:nth-child(3) {
      z-index: 1;
      grid-area: 1 / 4 / 2 / 6;
    }
    grid-column: auto;
  }
  /* lg to xl */
  @media ${({ theme }) => theme.breakpoints.xl} {
    grid-template-columns: auto min-content;
    height: 75vh;
    &:nth-child(1) {
      z-index: 3;
      grid-area: 1 / 1 / 2 / 3;
    }
    &:nth-child(2) {
      z-index: 2;
      grid-area: 1 / 2 / 2 / 5;
    }
    &:nth-child(3) {
      z-index: 1;
      grid-area: 1 / 4 / 2 / 6;
    }
    grid-column: auto;
  }
`;

export const HighlightsItemHeaderInner = styled.div`
  position: relative;
  border-bottom: 1px solid ${({ theme }) => theme.colors.onyx};
  margin: ${({ theme }) => `
    0
    ${fluid({
      minSize: theme.spacing.card.xs,
      maxSize: theme.spacing.card.md,
      minVW: theme.breakpointValues.xs,
      maxVW: theme.breakpointValues.md,
      baseFontMin: theme.baseFont.xs,
      baseFontMax: theme.baseFont.md,
    })}
  `};
  padding: ${({ theme }) => `
    ${fluid({
      minSize: theme.spacing.card.xs,
      maxSize: theme.spacing.card.md,
      minVW: theme.breakpointValues.xs,
      maxVW: theme.breakpointValues.md,
      baseFontMin: theme.baseFont.xs,
      baseFontMax: theme.baseFont.md,
    })}
    0
    calc(${fluid({
      minSize: theme.spacing.card.xs,
      maxSize: theme.spacing.card.md,
      minVW: theme.breakpointValues.xs,
      maxVW: theme.breakpointValues.md,
      baseFontMin: theme.baseFont.xs,
      baseFontMax: theme.baseFont.md,
    })} / 2)
  `};
  /* xs only */
  @media ${({ theme }) => theme.breakpoints.xs},
    /* sm and up */ ${({ theme }) => theme.breakpoints.sm},
    /* sm to md */ ${({ theme }) => theme.breakpoints.md} {
    display: flex;
    flex-direction: row-reverse;
    justify-content: space-between;
    align-items: center;
  }
  /* md and up */
  @media ${({ theme }) => theme.breakpoints.lg},
    /* lg to xl */ ${({ theme }) => theme.breakpoints.xl} {
    grid-column: 2 / 3;
    align-self: stretch;
    justify-self: end;
    border-left: 1px solid ${({ theme }) => theme.colors.onyx};
    border-bottom: none;
    margin: ${({ theme }) => `
      ${fluid({
        minSize: theme.spacing.card.md,
        maxSize: theme.spacing.card.xl,
        minVW: theme.breakpointValues.md,
        maxVW: theme.breakpointValues.xl,
        baseFontMin: theme.baseFont.md,
        baseFontMax: theme.baseFont.xl,
      })}
      ${fluid({
        minSize: theme.spacing.card.md,
        maxSize: theme.spacing.card.xl,
        minVW: theme.breakpointValues.md,
        maxVW: theme.breakpointValues.xl,
        baseFontMin: theme.baseFont.md,
        baseFontMax: theme.baseFont.xl,
      })}
      ${fluid({
        minSize: theme.spacing.card.md,
        maxSize: theme.spacing.card.xl,
        minVW: theme.breakpointValues.md,
        maxVW: theme.breakpointValues.xl,
        baseFontMin: theme.baseFont.md,
        baseFontMax: theme.baseFont.xl,
      })}
      0
    `};
    padding: ${({ theme }) => `
      0
      0
      0
    ${fluid({
      minSize: theme.spacing.card.md,
      maxSize: theme.spacing.card.xl,
      minVW: theme.breakpointValues.md,
      maxVW: theme.breakpointValues.xl,
      baseFontMin: theme.baseFont.md,
      baseFontMax: theme.baseFont.xl,
    })}
  `};
  }
`;

export const HighlightsItemHeaderWrapper = styled.div`
  /* xs only */
  @media ${({ theme }) => theme.breakpoints.xs} {
    display: flex;
    flex-flow: column;
    justify-content: space-between;
  }
  /* sm and up */
  @media ${({ theme }) => theme.breakpoints.sm} {
    display: flex;
    flex-flow: column;
    justify-content: space-between;
  }
  /* sm to md */
  @media ${({ theme }) => theme.breakpoints.md} {
    display: flex;
    flex-flow: column;
    justify-content: space-between;
    /* order: 1; */
  }
  /* md and up */
  @media ${({ theme }) => theme.breakpoints.lg} {
    box-sizing: border-box;
    cursor: pointer;
    user-select: none;
    display: grid;
    align-self: stretch;
    padding-left: ${({ theme }) => theme.spacing.form.lg};
  }
  /* lg to xl */
  @media ${({ theme }) => theme.breakpoints.xl} {
    box-sizing: border-box;
    cursor: pointer;
    user-select: none;
    display: grid;
    align-self: stretch;
    padding-left: ${({ theme }) => theme.spacing.form.xl};
  }
`;

export const HighlightsItemHeaderLabelWrapper = styled.div`
  position: relative;
  /* md and up */
  @media ${({ theme }) => theme.breakpoints.lg} {
    position: absolute;
    bottom: 0;
    right: ${({ theme }) => theme.spacing.form.lg}rem;
  }
  /* lg to xl */
  @media ${({ theme }) => theme.breakpoints.xl} {
    position: absolute;
    bottom: 0;
    right: ${({ theme }) => theme.spacing.form.xl}rem;
  }
`;

export const HighlightsItemHeaderLabel = styled(TypoCaption3)`
  white-space: nowrap;
  display: flex;
  /* md and up */
  @media ${({ theme }) => theme.breakpoints.lg},
    /* lg to xl */ ${({ theme }) => theme.breakpoints.xl} {
    transform: rotate(90deg);
    transform-origin: bottom right;
  }
`;

export const HighlightsItemContentInner = styled.div`
  padding: ${({ theme }) => `
    0
    ${fluid({
      minSize: theme.spacing.card.xs,
      maxSize: theme.spacing.card.md,
      minVW: theme.breakpointValues.xs,
      maxVW: theme.breakpointValues.md,
      baseFontMin: theme.baseFont.xs,
      baseFontMax: theme.baseFont.md,
    })}
  `};
  /* md and up */
  @media ${({ theme }) => theme.breakpoints.lg},
    /* lg to xl */ ${({ theme }) => theme.breakpoints.xl} {
    overflow: auto;
    overflow-y: scroll;
    padding: ${({ theme }) => `
      0
      ${fluid({
        minSize: theme.spacing.card.md,
        maxSize: theme.spacing.card.xl,
        minVW: theme.breakpointValues.md,
        maxVW: theme.breakpointValues.xl,
        baseFontMin: theme.baseFont.md,
        baseFontMax: theme.baseFont.xl,
      })}
      0
      calc(${fluid({
        minSize: theme.spacing.card.md,
        maxSize: theme.spacing.card.xl,
        minVW: theme.breakpointValues.md,
        maxVW: theme.breakpointValues.xl,
        baseFontMin: theme.baseFont.md,
        baseFontMax: theme.baseFont.xl,
      })} * 2)
    `};
  }
`;

export const HighlightsItemContentWrapper = styled.div`
  width: 100%;
  box-sizing: border-box;
  overflow: hidden;
  display: flex;
  flex-flow: column;
  p {
    &:first-of-type {
      padding-top: 0;
    }
  }
  padding: ${({ theme }) => `
    ${fluid({
      minSize: theme.spacing.card.xs,
      maxSize: theme.spacing.card.xl,
      minVW: theme.breakpointValues.xs,
      maxVW: theme.breakpointValues.xl,
      baseFontMin: theme.baseFont.xs,
      baseFontMax: theme.baseFont.xl,
    })}
    0
  `};
  /* md and up */
  @media ${({ theme }) => theme.breakpoints.lg} {
    grid-area: 1 / 1 / 2 / 2;
  }
  /* lg to xl */
  @media ${({ theme }) => theme.breakpoints.xl} {
    grid-area: 1 / 1 / 2 / 2;
  }
`;
